import { Box, Typography, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Nav = () => {
    const location = useLocation();
    const [ viewMenu, setViewMenu ] = useState(false);

    useEffect(()=>{
        setViewMenu(false)
    }, [location.hash])

    const handleMenu = (ev) => {
        ev.preventDefault();
        setViewMenu(!viewMenu);
    };

    return (
        <>
            <Box sx={{
                zIndex: 100,
                position: 'fixed',
                width: '100%',
                height: '4rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(12px)',
                borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
            }}>
                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '85%'}}>
                    <Box sx={{flexGrow: '1', display: 'flex', justifyContent: 'center', textDecoration: 'none'}} component={Link} to='/'>
                        <Typography variant="title" sx={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            whiteSpace: 'nowrap'
                        }}>LUCA LIU</Typography>
                    </Box>
                    <Box sx={{flexGrow: '3', display: {xs: 'none', md: 'flex'}, flexDirection: 'row', maxWidth: '100%', minWidth: '30%', justifyContent: 'center', alignItems: 'center', gap: '0.5rem'}}>
                        <Button variant="navigation-button" component={Link} to='/#aboutme'>
                            About Me
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#work-history'>
                            Work History
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#skills'>
                            Skills
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#projects'>
                            Projects
                        </Button>
                    </Box>
                    <Box sx={{flexGrow: '1', display: {xs: 'none', md: 'flex'}, justifyContent: 'center'}}>
                        <Button
                            variant="contained"
                            component={Link}
                            to='/#contactme'
                            sx={{
                                backgroundColor: '#3b82f6',
                                color: 'white',
                                padding: '0.6rem 1.5rem',
                                fontWeight: 600,
                                boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
                                '&:hover': {
                                    backgroundColor: '#1d4ed8',
                                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                                    transform: 'translateY(-1px)'
                                }
                            }}
                        >
                            Contact Me
                        </Button>
                    </Box>
                </Box>
                <Box sx={{display: {xs: 'flex', md: 'none'}, position: 'absolute', right: '1rem'}}>
                    <Button onClick={(ev)=>{handleMenu(ev)}} sx={{minWidth: 'auto', padding: '0.5rem'}}>
                        <MenuIcon sx={{color: '#475569'}} />
                    </Button>
                </Box>
            </Box>
            <Box sx={{
                display: {xs: 'flex', md: 'none'},
                width: '100%',
                height: '100%',
                zIndex: 200,
                top: '0',
                right: viewMenu ? "0" : "-100%",
                position: 'fixed',
                transition: 'right 0.35s ease-in-out'
            }}>
                <Box sx={{width: '100%', height: '100%', backgroundColor: 'rgba(15, 23, 42, 0.5)', backdropFilter: 'blur(4px)', position: 'absolute'}} onClick={() => setViewMenu(false)} />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '70%',
                    height: '100%',
                    backgroundColor: '#ffffff',
                    position: 'absolute',
                    zIndex: 200,
                    top: '0',
                    right: '0',
                    boxShadow: '-4px 0 20px rgba(0,0,0,0.1)'
                }}>
                    <Box sx={{right: '1rem', display: 'flex', height: '4rem', position: 'absolute', alignItems: 'center'}}>
                        <Button onClick={(ev)=>{handleMenu(ev)}} sx={{minWidth: 'auto', padding: '0.5rem'}}>
                            <CloseIcon sx={{color: '#475569'}} />
                        </Button>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center', gap: '1rem'}}>
                        <Button variant="navigation-button" component={Link} to='/#aboutme' sx={{fontSize: '1.1rem', padding: '0.75rem 1.5rem'}}>
                            About Me
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#work-history' sx={{fontSize: '1.1rem', padding: '0.75rem 1.5rem'}}>
                            Work History
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#skills' sx={{fontSize: '1.1rem', padding: '0.75rem 1.5rem'}}>
                            Skills
                        </Button>
                        <Button variant="navigation-button" component={Link} to='/#projects' sx={{fontSize: '1.1rem', padding: '0.75rem 1.5rem'}}>
                            Projects
                        </Button>
                        <Button
                            variant="contained"
                            component={Link}
                            to='/#contactme'
                            sx={{
                                backgroundColor: '#3b82f6',
                                color: 'white',
                                fontSize: '1.1rem',
                                padding: '0.75rem 2rem',
                                fontWeight: 600,
                                marginTop: '1rem'
                            }}
                        >
                            Contact Me
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default Nav;